module.exports = __webpack_public_path__ + "static/img/tabsbg02.f508c901.png";